import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import app from 'flarum/forum/app';
import { Vnode } from 'mithril';
import Mithril from 'mithril';
import LogInModal from "flarum/forum/components/LogInModal";
import LayaSignUpModal from './LayaSignUpModal';
import LayaForgotPasswordModal from './LayaForgotPasswordModal';
import { isWeChat, getErrorMessage } from '../../common/utils';

export default class LayaLogInModal extends LogInModal {
  phone!: Stream<string>;
  password!: Stream<string>;
  activeTab: 'password' | 'wechat' = 'password';
  qrCodeUrl: string = '';
  loading: boolean = false;

  oninit(vnode: Vnode) {
    super.oninit(vnode);
    this.phone = Stream('');
    this.password = Stream('');
  }

  className() {
    return 'LayaLogInModal Modal--small';
  }

  title() {
    return app.translator.trans('core.forum.log_in.title');
  }

  content() {
    return [
      m('.Modal-body', [this.activeTab == 'wechat' ? this.wechatLoginView() : this.passwordLoginView()]),
      this.footer()
    ]

  }

  footer() {
    return m('.Modal-footer', [
      m('p.LogInModal-forgotPassword', m('a', {
        onclick: () => {
          app.modal.show(LayaForgotPasswordModal);
        }
      }, app.translator.trans('core.forum.log_in.forgot_password_link'))),
      m("p.LogInModal-signUp", [
        app.translator.trans('core.forum.log_in.sign_up_text', {
          a: m('a', {
            onclick: () => {
              app.modal.show(LayaSignUpModal)
            }
          })
        })
      ])
    ])
  }

  passwordLoginView() {
    return m('.Form.Form--centered', { onsubmit: this.onsubmit.bind(this), autocomplete: 'off' }, [
      m('.Form-group', [
        m('input.FormControl', {
          name: 'phone',
          type: 'text',
          placeholder: app.translator.trans('laya-auth.forum.log_in.phone_placeholder'),
          oninput: (e: Event) => this.phone((e.target as HTMLInputElement).value),
          value: this.phone(),
          disabled: this.loading,
          autocomplete: 'off',
        }),
      ]),
      m('.Form-group', [
        m('input.FormControl', {
          name: 'password',
          type: 'password',
          placeholder: app.translator.trans('laya-auth.forum.sign_up.password_placeholder'),
          oninput: (e: Event) => this.password((e.target as HTMLInputElement).value),
          value: this.password(),
          disabled: this.loading,
          autocomplete: 'off',
        }),
      ]),
      m('.Form-group', [
        m(Button, {
          className: 'Button Button--primary Button--block',
          type: 'submit',
          loading: this.loading,
        }, app.translator.trans('core.forum.log_in.submit_button')),
      ]),
      // 添加微信登录按钮
      m('.Form-group', [
        m(Button, {
          className: 'Button Button--secondary Button--block Button--wechat',
          onclick: () => {
            this.loadQrCode();
          },
          disabled: this.loading,
        }, app.translator.trans('laya-auth.forum.log_in.with_wechat_button')),
      ]),
    ]);
  }

  wechatLoginView() {
    // 使用 iframe 嵌入微信登录，添加 sandbox 属性允许顶层导航
    let url = new URL(window.location.href);
    url.searchParams.delete('token')
    const wechatLoginUrl = 'https://api.masteropen.layabox.com/third/wxlogin?jumpurl=' + encodeURIComponent(url.href) + '&account=huo5game';

    return m('.Form.Form--centered', [
      m('iframe', {
        className: 'Wechat-login-iframe',
        src: wechatLoginUrl,
        width: '100%',
        height: '400px',
        sandbox: 'allow-scripts allow-top-navigation allow-top-navigation-by-user-activation allow-same-origin allow-forms allow-popups',
      }),
      m('.Form-group', [
        m(Button, {
          className: 'Button Button--primary Button--block Button--mobile',
          onclick: () => {
            this.activeTab = 'password'
            m.redraw();
          },
          disabled: this.loading,
        }, app.translator.trans('laya-auth.forum.log_in.with_mobile_button')),
      ]),
    ]);
  }
  loadQrCode() {
    let url = new URL(window.location.href);
    url.searchParams.delete('token')
    if (isWeChat()) {
      window.location.href = `https://api.masteropen.layabox.com/third/wx?jumpurl=${encodeURIComponent(url.href)}&account=huo5game`
    } else {
      this.activeTab = 'wechat';
      m.redraw();
      // window.open(`https://api.masteropen.layabox.com/third/wxlogin?jumpurl=${encodeURIComponent(url.href)}&account=huo5game`)
    }


  }

  onsubmit(e: SubmitEvent) {
    e.preventDefault();
    this.loading = true;

    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/laya/login',
      body: {
        phone: this.phone(),
        password: this.password(),
      },
      errorHandler: (error: any) => {
        this.loading = false;
        m.redraw();
        // 尝试多种方式获取 ret 错误码和 msg
        const ret = error?.response?.ret ?? error?.responseJSON?.ret ?? error?.body?.ret ?? error?.ret;
        const msg = error?.response?.msg ?? error?.responseJSON?.msg ?? error?.body?.msg ?? error?.msg;
        if (ret !== undefined && ret !== null) {
          app.alerts.show({ type: 'error' }, getErrorMessage(ret, msg));
          return;
        }
        this.onerror(error);
      },
    }).then((response: any) => {
      // 检查 API 返回的 ret 错误码
      if (response && response.ret !== undefined && response.ret !== 0) {
        this.loading = false;
        m.redraw();
        app.alerts.show({ type: 'error' }, getErrorMessage(response.ret, response.msg));
        return;
      }
      window.location.reload();
    });
  }
}
